export default "__VITE_ASSET__4c299516__"